import { Component, Inject, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Config, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as merge from 'lodash.merge';
import * as moment from 'moment';
import 'moment/locale/de';
import * as nestedProperty from 'nested-property';
import { Subscription } from 'rxjs';
import {mergeMap} from 'rxjs/operators';
// import { register } from 'swiper/element/bundle';

import {Apptext} from 'shared/apptext/model/model';
import {ApptextService} from 'shared/apptext/services/apptext.service';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';

import * as teams from 'shared/teams/teams-checker';
import { Router } from '@angular/router';

import { App, URLOpenListenerEvent } from '@capacitor/app';
import { HyphenateService } from 'shared/helpers/hyphenate.service';
import { KeyValue } from '@angular/common';

//import { StatusBar, Style } from '@capacitor/status-bar';
// register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public theme: string = '';
  public platforms: string = '';
  public mode: string = '';
  private subscription: Subscription;

  private uncachedApptextsAlreadyLoaded: boolean = false;

  constructor(
    private platform: Platform,
    private apptextService: ApptextService,
    private translateService: TranslateService,
    private config: Config,
    private screenOrientation: ScreenOrientation,
    private localSettingsService: LocalSettingsService,
    private router: Router,
    private zone: NgZone,
    private hyphenateService: HyphenateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.initializeApp();
  }

  private async initializeApp(): Promise<void> {
    this.setupLanguage();
    this.loadApptexts();
    
    this.platform.ready().then((readySource) => {
      // console.log('Platform ready from', readySource);

      this.platforms = 'pf-' + this.platform.platforms().join(' pf-');
      this.theme = this.platforms;

      try {
        if (this.platform.is('capacitor')) {
  //        this.statusBar.styleDefault();
          this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);

          App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            this.zone.run(() => {
              // Example url: https://beerswift.app/tabs/tab2
                // slug = /tabs/tab2
                const link = event.url.split("/app/").pop();
                if (link) {
                  console.log('Deeplink '+link)
                  if ( link.indexOf("addLeader=") == 0 ) {
                    this.router.navigateByUrl('/profile/addleader', {state: {leaderId: link.substring(10)}} );
                  }
                }
                // If no match, do nothing - let regular routing
                // logic take over
            });
        });
        }
        else {
          // allow Zooming 
          const viewport = this.document.querySelector('meta[name=viewport');
          if ( viewport !== undefined ) {
            viewport.setAttribute('content', 'viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0, user-scalable=yes');
          }
        }

      } catch (error) {
        // tslint:disable-next-line:no-console
        console.error(error);
      } finally {
      }

      /*console.log("ZZZZZ 0");
      if ( this.platform.is('capacitor') && this.platform.is('android') ) {
        console.log("ZZZZZ 1");
        setTimeout(() => {
          console.log("ZZZZZ 2");
          StatusBar.setOverlaysWebView({ overlay: false });
          setTimeout(() => {
            console.log("ZZZZZ 3");
            StatusBar.setOverlaysWebView({ overlay: true });
            setTimeout(() => {
              console.log("ZZZZZ 4");
              StatusBar.setOverlaysWebView({ overlay: false });
            }, 100);
          }, 100);
        }, 100);
      }*/
    });

    this.subscription = this.localSettingsService.settingChanged$
      .subscribe((kv: KeyValue<string, string>) => {
        if (kv.key == LocalSettingsService.THEME) {
          this.theme = kv.value + ' ' + this.platforms + (teams.checkInTeams() ? ' teams' : '');
          this.hyphenateService.setTheme(kv.value);
        }
        if (kv.key == LocalSettingsService.LANGUAGE) {
          this.translateService.use(kv.value);
          moment.locale(kv.value);
          this.hyphenateService.setHyphenateFunction(kv.value);
          this.document.documentElement.lang = kv.value;
        }
        if (kv.key == LocalSettingsService.MODE) {
          this.mode = kv.value+'_mode';
        }
      });

    this.localSettingsService.doWaiting(this.setTheme.bind(this));
    this.localSettingsService.doWaiting(this.setLanguageFromSettings.bind(this));
    this.localSettingsService.doWaiting(this.setMode.bind(this));
  }

  public setTheme(): void {
    this.localSettingsService.get(LocalSettingsService.THEME)
      .then((result) => {
        if (result) {
          this.theme = result + ' ' + this.platforms + (teams.checkInTeams() ? ' teams' : '');
          this.hyphenateService.setTheme(result);
        }
      });
  }

  private setupLanguage(): void {
    const supportedLanguages: Array<string> = ['en', 'de'];
    const defaultLang: string = supportedLanguages[0];
    let lang: string;

    if (navigator.language) {
      console.log('navigator.language: ' + navigator.language);
      lang = navigator.language.split('-')[0];
    } else {
      console.log('fallback language: ' + defaultLang);
      lang = defaultLang;
    }

    if (supportedLanguages.indexOf(lang) < 0) {
      lang = defaultLang;
    }

    console.log("LANG: " + lang)
    this.translateService.use(lang);
    moment.locale(lang);
    this.hyphenateService.setHyphenateFunction(lang);
    this.document.documentElement.lang = lang;
  }

  public setMode(): void {
    this.localSettingsService.get(LocalSettingsService.MODE)
      .then((result) => {
        if (result !== null && result != this.mode) {
          this.mode = result+'_mode';
        }
      });
  }

  public setLanguageFromSettings(): void {
    this.localSettingsService.get(LocalSettingsService.LANGUAGE)
      .then((lang) => {
        const curLang = this.translateService.currentLang;
        console.log("curr lang: "+ curLang);
        if (lang) {
          if (curLang != lang) {
            this.translateService.use(lang);
            moment.locale(lang);
            this.hyphenateService.setHyphenateFunction(lang);
            this.loadApptexts();
            this.document.documentElement.lang = lang;
          }
        }
        else {
          this.localSettingsService.set(LocalSettingsService.LANGUAGE, curLang);
        }
      });
  }

  private loadApptexts(): void {
    this.apptextService.getApptexts().subscribe((apptexts: Array<Apptext>) => {
      this.uncachedApptextsAlreadyLoaded = true;
      this._setApptexts(apptexts);
    });

    // cached apptexts are probably much faster to fetch and work offline,
    // so use these if the real apptexts arent already fetched
    this.localSettingsService.doWaiting(this._setCachedApptexts.bind(this));
  }

  private _setCachedApptexts() {
    this.apptextService.getCachedApptexts().subscribe((apptexts: Array<Apptext>) => {
      if (!this.uncachedApptextsAlreadyLoaded) {
        this._setApptexts(apptexts);
      }
    });
  }

  private _setApptexts = (apptexts: Array<Apptext>) => {
    const availableLanguages: Array<string> = this.translateService.getLangs();
    const translationObjects: {} = {};
    for (const apptext of apptexts) {
      const textKey: string = apptext.name;
      const languages: Array<string> = Object.keys(apptext.text)
        .filter((languageKey) => {
          return availableLanguages.indexOf(languageKey) >= 0;
        });

      for (const language of languages) {
        if (translationObjects[language] === undefined) {
          translationObjects[language] = {};
        }
        const translation: string = this._softHyphens(apptext.text[language]);
        this._updateTranslationObject(translationObjects[language], textKey, translation);
      }
    }

    /**
     * we need to use a translationObject with `setTranslation` instead of
     * the translationKey with `set`, because `set` doesn't interpret the
     * dots in the tranlsationKey, and just uses the key as is, instead of
     * traversing the translation object
     */
    for (const language in translationObjects) {
      this._updateApptextsForLanguage(language, translationObjects[language]);
    }
  }

  private _updateApptextsForLanguage(language: string, apptexts: {}): void {
    this.translateService.setTranslation(language, apptexts, true);
    // this.translateService.getTranslation(language)
    //   .subscribe((translation) => {
    //     this.translateService.setTranslation(language, merge(translation, apptexts));
    //   });
  }

  private _updateTranslationObject(translationObject: {}, key: string, translation: string): void {
    nestedProperty.set(translationObject, key, translation);
  }

  private _softHyphens(s: string): string {
    if ( s == 'Themenpakete' ) {
      s = 'Themen=pakete';
    }
    return s.replace(/(\S)=(\S)/g, '$1\u00AD$2');
  }

}
